import { render, staticRenderFns } from "./HotApps.vue?vue&type=template&id=51917a1a&scoped=true&"
import script from "./HotApps.vue?vue&type=script&lang=ts&"
export * from "./HotApps.vue?vue&type=script&lang=ts&"
import style0 from "./hot_apps.scss?vue&type=style&index=0&id=51917a1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51917a1a",
  null
  
)

export default component.exports